export const shuttleEpcFr = {
    api: {
        error: {
            createShuttleEpc: "Erreur lors de la création de l'EPC navette {name}",
            createShuttleEpcRange: 'Erreur lors de la création des EPCs navettes de {start} à {end}',
            deleteShuttleEpc: "Erreur lors de la suppression de l'EPC navette {name}",
            fetchShuttleEpcs: 'Erreur lors de la récupération des EPCs navettes'
        },
        success: {
            createShuttleEpc: "Création de l'EPC navette {name} effectuée avec succès !",
            createShuttleEpcRange:
                'EPCs navettes de {start} à {end} : {created} créé(s), {skipped} déjà existant(s)',
            deleteShuttleEpc: "Suppression de l'EPC navette {name} effectuée avec succès !",
            fetchShuttleEpcs: 'Récupération des EPCs navettes effectuée avec succès !'
        }
    },
    buttons: {
        create: 'Ajouter un EPC navette',
        createRange: "Ajouter une plage d'EPC navettes"
    },
    dialog: {
        createTitle: 'Ajouter un EPC navette',
        epcPlaceholder: 'Saisissez le code EPC',
        createRangeTitle: "Ajouter une plage d'EPC navettes",
        rangeStart: 'Premier EPC',
        rangeEnd: 'Dernier EPC',
        rangeHint:
            'Les EPC sont numériques et incrémentés en base 10 (bornes incluses). Les EPC déjà existants sont ignorés.',
        rangeCount: '{count} EPC seront ajoutés',
        rangeErrors: {
            digits: 'Les EPC ne doivent contenir que des chiffres',
            length: 'Le premier et le dernier EPC doivent avoir la même longueur',
            order: 'Le dernier EPC doit être supérieur ou égal au premier',
            max: 'Une plage ne peut pas dépasser {max} EPC'
        }
    },
    model: {
        epc: 'EPC',
        createdAt: 'Date de création'
    },
    table: {
        id: 'ID',
        epc: 'EPC',
        createdAt: 'Date de création'
    }
}
